import { render, staticRenderFns } from "./collection-action-area.vue?vue&type=template&id=aef8b94a&scoped=true"
import script from "./collection-action-area.vue?vue&type=script&lang=ts"
export * from "./collection-action-area.vue?vue&type=script&lang=ts"
import style0 from "./collection-action-area.vue?vue&type=style&index=0&id=aef8b94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef8b94a",
  null
  
)

export default component.exports